module.exports = __webpack_public_path__ + "img/honer3.117792e1.jpg";